module.exports = __webpack_public_path__ + "img/up_res_projects.0a606e7b.svg";